import React from 'react';

const SentryFallbackComponent = ({ error, componentStack, resetError }: any) => {
    return (
        <>
            <div>You have encountered an error</div>
            <div>{error.toString()}</div>
            <div>{componentStack}</div>
            <button data-qaid="reload_button" onClick={resetError}>
                Click here to reload
            </button>
        </>
    );
};

export default SentryFallbackComponent;
